import React, { useContext } from "react";
/**
 * 最近使用和常用应用本地存储的工具文件
 */

import { FavoriteType, TopType } from "@/services/AppStore";
import { updateTypePredicateNodeWithModifier } from "typescript";
import { EventEmitter } from "events";
import { FocusSDK, getWebEnvObj, isFocusEnv } from "@/utils";
import { WebAppTrailApply } from "@jd/focus-desktop-comps";
import { judgeFreeUse } from "@/api/appStore";
import getAppEntry from "@/utils/entry";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import { AuthData } from "@/types/LocalConfig";
import { getAppVersion } from "@/utils/getVersion";
import { GATEWAY_VERSION } from "@/server/constants";

export const LOCAL_FAVORITE = "favoriteApplicationArr";
export const LOCAL_RECENT = "recentApplicationArr";
export const SORT_BY_CLICK_NUM = "sortByClickNumArr";

export const RECENT_MAX_LEN = 4;
export const SORT_BY_CLICK_NUM_MAX_LEN = 24;

export enum FavoviteSortType {
  BySort = "1",
  Favorite = "2"
}

/**
 * 处理数据，初始化常用应用列表和最近使用列表
 */
// eslint-disable-next-line max-params
export function dealThirdApplications (
  key: string,
  favoriteIds: any[],
  thirdApplications: any[],
  topAppIds: string[],
  recentId: string
) {
  const deviceInfo = FocusSDK.getDeviceInfo();
  console.log("this is deviceInfo", deviceInfo);
  const favorite: any[] = [];
  const topApps: any[] = [];
  // const recent: any[] = [];
  // const recentIds: any[] = getLocalRecent(key) || [];
  let appObj: any | null = {};
  // console.log("this is top app ids ", topAppIds);
  // topAppIds.push("nzNMtuL82Qq7mvpplgxA");
  thirdApplications.forEach((item: any) => {
    item.applications.forEach((appInfo: any) => {
      appInfo.favorite = FavoriteType.FavoriteNo;
      appInfo.topType = TopType.TopNo;
      // appInfo.isOnlyMobile = true;
      // appInfo.isVisible = false;
      appObj[appInfo.applicationId] = appInfo;
    });
  });

  topAppIds.forEach((id: string) => {
    const appInfo = appObj[id];
    thirdApplications.forEach((item: any) => {
      const index = item.applications.findIndex((i: any) => i.applicationId === id);
      const obj = item.applications[index];
      obj && (obj.topType = TopType.TopYes);
    });
    if (appInfo) {
      appInfo.topType = TopType.TopYes;
      topApps.push(appInfo);
    }
  });

  favoriteIds.forEach((id: string) => {
    if (topAppIds.includes(id)) {
      return;
    }
    const appInfo = appObj[id];
    thirdApplications.forEach((item: any) => {
      const index = item.applications.findIndex((i: any) => i.applicationId === id);
      const obj = item.applications[index];
      obj && (obj.favorite = FavoriteType.FavoriteYes);
    });
    if (appInfo) {
      appInfo.favorite = FavoriteType.FavoriteYes;
      favorite.push(appInfo);
    }
  });

  // recentIds.forEach((id: string) => {
  //   const appInfo = appObj[id];
  //   if (appInfo) {
  //     recent.push(appInfo);
  //   }
  // });

  appObj = null;

  setLocalFavorite(
    key,
    favorite.map((i) => i.applicationId)
  );
  // setLocalRecent(
  //   key,
  //   recent.map((i) => i.applicationId)
  // );
  const recent = dealRecentGroup(key, thirdApplications, recentId);
  return {
    favorite: topApps.concat(favorite),
    recent,
    thirdApplications
  };
}

/**
 * 添加常用应用
 */
export function addFavorite (key: string, id: string) {
  const favoriteArr = getLocalFavorite(key);
  favoriteArr?.push(id);
  setLocalFavorite(key, favoriteArr || []);
}

/**
 * 移除常用应用
 */
export function removeFavorite (key: string, id: string) {
  const favoriteArr = getLocalFavorite(key);
  setLocalFavorite(key, favoriteArr?.filter((i: string) => i !== id) || []);
}

/**
 * 处理最近使用
 * @params{
 *  theThirdAppListAll //curThirdAppListAll为异步赋值，当curThirdAppListAll还没有值时使用theThirdAppListAll的值
 * }
 */
// eslint-disable-next-line max-params
export function dealRecent (
  key: string,
  curitem: any,
  thirdAppListAll: any[],
  recentGroup: any,
  info: any
) {
  let item = curitem;
  // 应用没有权限时不去设置常用应用
  if (!curitem && !info) {
    return false;
  }

  // 当前缓存的全部应用中不存在该应用（刚设置可见性还没有刷新数据，搜索出来的应用）
  if (info && !curitem) {
    item = transformInfo(info);
  }

  const thirdAppIdsList = thirdAppListAll.map((i: any) => i.groupId);
  const recentGroupId = recentGroup.groupId;

  let recentArr;
  if (thirdAppIdsList.includes(recentGroupId)) {
    recentArr = thirdAppListAll[thirdAppIdsList.indexOf(recentGroupId)].applications;
  } else {
    thirdAppListAll.splice(1, 0, recentGroup);
    recentArr = recentGroup.applications;
  }

  const recentIds = recentArr.map((i: any) => i.applicationId);
  if (recentIds.includes(item.applicationId)) {
    const index = recentIds.indexOf(item.applicationId);
    const theItem = recentArr.splice(index, 1)[0];
    recentArr.unshift(theItem);
  } else {
    recentArr.unshift(item);
    if (recentArr.length > RECENT_MAX_LEN) {
      recentArr.pop();
    }
  }
  setLocalRecent(
    key,
    recentArr.map((i: any) => i.applicationId)
  );
  return recentArr;
}

/**
 * 处理常用应用，切换排序方式
 */
export function dealRecentGroup (key: string, thirdAppListAll: any[], recentId: any) {
  const thirdAppIdsList = thirdAppListAll.map((i: any) => i.groupId);
  const recentGroup = thirdAppListAll[thirdAppIdsList.indexOf(recentId)];
  let favoriteIds = getLocalSortByClickNum(key)?.map((item) => item.id);
  // console.log("this is favoriteids", favoriteIds);
  if (!favoriteIds || favoriteIds.length === 0) {
    favoriteIds = getLocalFavorite(key) || [];
    setLocalSortByClickNum(
      key,
      favoriteIds?.map((id) => {
        return { id: id, num: 0 };
      })
    );
  }
  const recentApplications = getThirdappByIds(thirdAppListAll, favoriteIds || []).slice(
    0,
    SORT_BY_CLICK_NUM_MAX_LEN
  );
  if (recentGroup) {
    recentGroup.applications = recentApplications;
  }
  return recentApplications;
}

/**
 * 根据id数组，获取应用数组
 */
export function getThirdappByIds(thirdappListAll: any[], ids: string[]) {
  const appObj: any = {};
  thirdappListAll.forEach((item: any) => {
    item.applications?.forEach((appInfo: any) => {
      appObj[appInfo.applicationId] = appInfo;
    });
  });
  const result: any[] = [];
  ids.forEach((id: string) => {
    if (appObj[id]) {
      result.push(appObj[id]);
    }
  });
  return result;
}

/**
 * 处理按使用频次排序
 */
// eslint-disable-next-line max-params
export function dealSortByClickNum (key: string, curitem: any, info: any) {
  let item = curitem;
  // 应用没有权限时不去设置常用应用
  if (!curitem && !info) {
    return false;
  }

  // 当前缓存的全部应用中不存在该应用（刚设置可见性还没有刷新数据，搜索出来的应用）
  if (info && !curitem) {
    item = transformInfo(info);
  }

  let clickNumArr = getLocalSortByClickNum(key) || [];
  const clickNumIds = clickNumArr.map((item) => item.id);
  if (clickNumIds.includes(item.applicationId)) {
    const curObj = clickNumArr[clickNumIds.indexOf(item.applicationId)];
    curObj.num += 1;
  } else {
    clickNumArr.push({ id: item.applicationId, num: 1 });
  }
  const sortArr = clickNumArr?.sort((a, b) => b.num - a.num);
  setLocalSortByClickNum(key, sortArr || []);
}

/**
 * 存储常用应用
 */
export function setLocalFavorite (key: string, arr: any[]) {
  return localStorage.setItem(`${key}_${LOCAL_FAVORITE}`, JSON.stringify(arr));
}

/**
 * 获取本地常用应用列表
 */
export function getLocalFavorite (key: string): any[] | null {
  localStorage.removeItem(LOCAL_FAVORITE);
  const str = localStorage.getItem(`${key}_${LOCAL_FAVORITE}`);
  if (!str) {
    return null;
  }
  return JSON.parse(str);
}

/**
 * 移除localstorage中的常用应用列表
 */
export function removeLocalFavorite (key: string) {
  return localStorage.removeItem(`${key}_${LOCAL_FAVORITE}`);
}

/**
 * 存储最近使用
 */
export function setLocalRecent (key: string, arr: any[]) {
  return localStorage.setItem(`${key}_${LOCAL_RECENT}`, JSON.stringify(arr));
}

/**
 * 获取最近使用列表
 */
export function getLocalRecent (key: string): any[] | null {
  localStorage.removeItem(LOCAL_RECENT);
  const str = localStorage.getItem(`${key}_${LOCAL_RECENT}`);
  if (!str) {
    return null;
  }
  return JSON.parse(str);
}

/**
 * 存储按使用频次排序列表
 */
export function setLocalSortByClickNum(key: string, arr: any[]) {
  return localStorage.setItem(`${key}_${SORT_BY_CLICK_NUM}`, JSON.stringify(arr));
}
/**
 * 获取按使用频次排序列表
 */
export function getLocalSortByClickNum(key: string): any[] | null {
  const str = localStorage.getItem(`${key}_${SORT_BY_CLICK_NUM}`);
  if (!str) {
    return null;
  }
  return JSON.parse(str);
}

/**
 * 根据传入的应用列表，标记已经添加为常用的应用
 */
export function markFavorite (key: string, apps: any[], topAppIds: string[]) {
  const favorites = getLocalFavorite(key);
  return apps.map((app) => {
    if (favorites?.includes(app.applicationId)) {
      app.favorite = FavoriteType.FavoriteYes;
    } else {
      app.favorite = FavoriteType.FavoriteNo;
    }
    if (topAppIds?.includes(app.applicationId)) {
      app.topType = TopType.TopYes;
    } else {
      app.topType = TopType.TopNo;
    }
    return app;
  });
}

/**
 * 搜索出来的应用转化为工作台中应用的数据结构
 */
export function transformInfo (item: any) {
  const newItem: any = { ...item, ...item.ext };
  newItem.icon = newItem.avatar;
  newItem.name = newItem.appName;
  delete newItem.ext;
  delete newItem.foreignLanguage;
  delete newItem.highlight;
  return newItem;
}

/**
 * 根据applicationKey获取应用
 */
export function getApplication (thirdAppListAll: any, fn: (a: any) => any) {
  const appLen = thirdAppListAll?.length;
  for (let i = 0; i < appLen; i++) {
    const theApplications = thirdAppListAll[i]?.applications;
    const len = theApplications?.length;
    for (let j = 0; j < len; j++) {
      const application = theApplications[j];
      if (fn(application)) {
        return application;
      }
    }
  }
  return null;
}

export const ThirdAppContext = React.createContext<{
  topAppIds: string[];
  isOnline: boolean;
  isActive: boolean;
  notifyer?: EventEmitter;
  onChangeFavoriteSortType?: (type: FavoviteSortType) => void;
  favoriteSortType?: FavoviteSortType;
}>({
  topAppIds: [],
  isOnline: true,
  isActive: true
});

export function scrollToTop (dom: any, scrollTop: number, duration: any) {
  if (scrollTop === 0) return;

  const old = dom.scrollTop;

  const cosParameter = (scrollTop - old) / 2;
  let scrollCount = 0;
  let oldTimestamp: any = null;

  function step (newTimestamp: any): any {
    if (oldTimestamp !== null) {
      // if duration is 0 scrollCount will be Infinity
      scrollCount += (Math.PI * (newTimestamp - oldTimestamp)) / duration;
      if (scrollCount >= Math.PI) return false;
      dom.scrollTop = cosParameter + cosParameter * -Math.cos(scrollCount) + old;
    }
    oldTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);
}
export const PerformanceContext = React.createContext<{
  appClickTime: number;
}>({
  appClickTime: 0
});

// eslint-disable-next-line max-params
export function appTrailApply (
  applicationId: string,
  defaultAction: () => void,
  notifyer?: EventEmitter,
  appInfo?: any,
  isInsideApp?: boolean,
  cb?: (showTrailDialog: boolean) => void,
  currentWinAppApply?: (url: string) => void
) {
  // TODO 捕获到异常如何处理
  judgeFreeUse({ applicationId: applicationId })
    .then((data: any) => {
      const appTrailStatus = getTrialStatus({ applyInfo: data, isInsideApp });
      console.log("appTrailStatus===>>>", appTrailStatus, data);
      let onOpenUrl;
      switch (appTrailStatus) {
        case AppTrialStatus.NORMAL:
          defaultAction?.();
          cb?.(false);
          break;
        case AppTrialStatus.FIRST_APPLY:
          if (isFocusEnv()) {
            onOpenUrl = () => {
              console.log("currentWinAppApply-->", typeof currentWinAppApply);
              if (currentWinAppApply) {
                currentWinAppApply?.(
                  `${getAppEntry()}/app-apply.html?applicationId=${applicationId}&trialDays=${
                    data.trialDays
                  }&isIndependent=true`
                );
                return;
              }
              notifyer?.emit("clientMessage", {
                event: "openNewWindow",
                payload: {
                  urls: [
                    `${getAppEntry()}/app-apply.html?applicationId=${applicationId}&trialDays=${
                      data.trialDays
                    }`
                  ],
                  name: appInfo?.name,
                  phone: appInfo?.csTelephone || "",
                  company: appInfo?.omCompany || "",
                  appKey: appInfo?.applicationKey,
                  trustedDomains: appInfo?.trustedDomains || "",
                  version: appInfo?.version,
                  isThirdApp: false
                }
              });
            };
          }
          WebAppTrailApply({
            applicationId: appInfo?.applicationId || applicationId,
            isExpired: false,
            isInsideApp,
            onOpenUrl,
            trialDays: data.trialDays || 0,
            env:
              process.env.REACT_APP_NODE_ENV === "production"
                ? "prod"
                : process.env.REACT_APP_NODE_ENV,
            applyPageUrl: `${getAppEntry()}/app-apply.html`
          });
          cb?.(true);
          break;
        case AppTrialStatus.APPLYING:
          WebAppTrailApply({
            applicationId: applicationId,
            isInsideApp,
            isUnApprove: true
          });
          cb?.(true);
          break;
        case AppTrialStatus.APPLY_EXPIRED:
          WebAppTrailApply({
            applicationId: appInfo?.applicationId || applicationId,
            isInsideApp,
            isExpired: true
          });
          cb?.(true);
          break;
      }
    })
    .catch((e) => {
      console.error(e);
      // Bus.emit("openThirdApp", appInfo);
      defaultAction?.();
      cb?.(false);
    });
}

export enum AppTrialStatus {
  NORMAL = "NORMAL",
  FIRST_APPLY = "FIRST_APPLY",
  APPLYING = "APPLYING",
  APPLY_EXPIRED = "APPLY_EXPIRED"
}

export function getTrialStatus ({
  applyInfo,
  isInsideApp
}: {
  applyInfo: {
    firstApply: boolean;
    expired: boolean;
    needToAddToStore: boolean;
    onTrail: boolean;
    applyUnApprove: boolean;
    onlyApp: boolean;
  };
  isInsideApp?: boolean;
}): AppTrialStatus {
  const firstApply = applyInfo.firstApply;
  const expired = applyInfo.expired;
  const needToAddToStore = applyInfo.needToAddToStore;
  const onTrail = applyInfo.onTrail;
  const applyUnApprove = applyInfo.applyUnApprove;
  const onlyApp = applyInfo.onlyApp;

  if (onlyApp !== null) {
    if (onlyApp === true) {
      // 只有应用内才允许走试用逻辑
      if (!isInsideApp) {
        // 不在应用内，正常打开应用
        return AppTrialStatus.NORMAL;
      }
    } else {
      // 只有应用外才允许走试用逻辑
      if (isInsideApp) {
        // 不在应用外，正常打开应用
        return AppTrialStatus.NORMAL;
      }
    }
  }

  if (needToAddToStore === null || !needToAddToStore!) {
    // 不在应用市场，正常使用
    return AppTrialStatus.NORMAL;
  }

  if (onTrail === null || !onTrail!) {
    // 不支持免费试用，正常使用
    return AppTrialStatus.NORMAL;
  }

  if (applyUnApprove !== null && applyUnApprove!) {
    // 已经申请过，正在审批中
    return AppTrialStatus.APPLYING;
  }

  if (firstApply !== null && firstApply!) {
    // 第一次使用，弹出申请框
    return AppTrialStatus.FIRST_APPLY;
  }
  if (expired !== null && expired!) {
    // 试用过期，弹出提示框
    return AppTrialStatus.APPLY_EXPIRED;
  }
  return AppTrialStatus.NORMAL;
}

export function getAppApplyStatus (applicationId: string, isInsideApp: boolean) {
  return new Promise((resolve, reject) => {
    judgeFreeUse({ applicationId })
      .then((res: any) => {
        const appTrialStatus = getTrialStatus({
          applyInfo: res,
          isInsideApp: isInsideApp
        });
        resolve(appTrialStatus);
      })
      .catch((e: any) => {
        resolve(AppTrialStatus.NORMAL);
      });
  });
}

export function getAppStoreUrl(appRuntimeEnv: AppRuntimeEnv, authInfo: AuthData) {
  try {
    const urlObj = new URL(`${appRuntimeEnv.meMainEntry}/app_store`);
    urlObj.searchParams.append("appKey", appRuntimeEnv.gateway.appId);
    urlObj.searchParams.append("appVersion", getAppVersion(FocusSDK));
    urlObj.searchParams.append(
      "client",
      (!isFocusEnv() && "web") || appRuntimeEnv.registryConfig.client
    );
    urlObj.searchParams.append("did", appRuntimeEnv.registryConfig.machineId);
    urlObj.searchParams.append("gwVersion", GATEWAY_VERSION as any);
    urlObj.searchParams.append("hostAppId", (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork");
    urlObj.searchParams.append("stage", appRuntimeEnv.gateway.stage);
    urlObj.searchParams.append("teamId", appRuntimeEnv.selectedTeamId);
    urlObj.searchParams.append("accessToken", authInfo.accessToken);
    let secretKey = "";
    if (FocusSDK.getDeviceInfo().platform === "web") {
      secretKey = getWebEnvObj().REACT_APP_WEB_SECRETKEY || "";
    } else {
      const name = appRuntimeEnv.runtimeConfig.key;
      secretKey = getWebEnvObj().REACT_APP_DESKTOP_SECRETKEY || "";;
    }
    urlObj.searchParams.append("secretKey", secretKey);
    return urlObj.toString();
  } catch (err) {
    console.log(err);
  }
}
